module.exports = __webpack_public_path__ + "static/media/picture_igor_hover.1e6a1a2d.jpg";